<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.name">
    
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.name }}</p>
      <!--<small>Available</small> -->
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <!-- <img v-if="this.photo" key="onlineImg" :src="this.photo" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" /> -->
        <vs-avatar width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div> 

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li 
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="profile">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">계정정보</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">로그아웃</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  computed: {
    activeUserInfo () {
      // console.log(this.$store.getters.getUserInfo.name)
      return this.$store.getters.getUserInfo
    }
    // photo () {
    //   console.log(`photo: ${this.$store.getters.getUserInfo.photo}`)
    //   const photo = this.$store.getters.getUserInfo.photo
    //   if (photo !== null) {
    //     return photo
    //   } else {
    //     return null
    //   }
    // }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
      this.$router.push('/login')
        .catch((error) => {
          console.log(error)
        })
    },
    profile () {
      this.$router.push('/profile')
    }
  }
}
</script>
